module.exports = __webpack_public_path__ + "img/concat.90c45509.png";